import React from "react";
import {BulkSyncResult, BulkSyncSummary} from "../../../../providers/fluentCRM/FluentCRMTypes";

interface BulkSyncReportProps {
    result: BulkSyncResult;
    summary: BulkSyncSummary;
}

export const BulkContactSyncReport: React.FC<BulkSyncReportProps> = ({result, summary}) => {
    return (
        <div className="space-y-6 font-sans text-sm text-gray-800">
            <div>
                <h2 className="text-lg font-semibold text-gray-900">Bulk Sync Summary</h2>
                <ul className="mt-2 space-y-1">
                    <li>
                        <span className="font-medium text-green-600">Created:</span>{" "}
                        {summary.createdCount}
                    </li>
                    <li>
                        <span className="font-medium text-blue-600">Updated:</span>{" "}
                        {summary.updatedCount}
                    </li>
                    <li>
                        <span className="font-medium text-red-600">Failed:</span>{" "}
                        {summary.failedCount}
                    </li>
                </ul>
            </div>

            <div>
                <h3 className="font-semibold text-gray-900">Created</h3>
                <ul className="list-disc list-inside ml-4 text-green-700">
                    {summary.createdEmails.length > 0 ? (
                        summary.createdEmails.map(email => <li key={email}>{email}</li>)
                    ) : (
                        <li className="italic text-gray-500">None</li>
                    )}
                </ul>
            </div>

            <div>
                <h3 className="font-semibold text-gray-900">Updated</h3>
                <ul className="list-disc list-inside ml-4 text-blue-700">
                    {summary.updatedEmails.length > 0 ? (
                        summary.updatedEmails.map(email => <li key={email}>{email}</li>)
                    ) : (
                        <li className="italic text-gray-500">None</li>
                    )}
                </ul>
            </div>

            <div>
                <h3 className="font-semibold text-gray-900">Failed</h3>
                <ul className="list-disc list-inside ml-4 text-red-700">
                    {summary.failed.length > 0 ? (
                        summary.failed.map(f => (
                            <li key={f.email}>
                                <span className="font-medium">{f.email}</span> – {f.error}
                            </li>
                        ))
                    ) : (
                        <li className="italic text-gray-500">None</li>
                    )}
                </ul>
            </div>
        </div>
    );
};
